import { useContext } from 'react';
import { TenantContext } from '../../../context/tenant-context';
import { handleRequest } from '../quipli-service-client';
import { Category, CategorySearchRequest, CategoryUpdateRequest } from './category';
import { CategoryParsers } from './category-parsers';

export const useCategoryApiV1 = () => {
  const { tenant, contextPath } = useContext(TenantContext);

  async function listCategories(includeInactive: boolean = false) {
    const config = {
      method: 'get',
      url: `${contextPath}quipli-service/yorent/v1/categories?includeInactive=${includeInactive}`,
      headers: {
        'X-Tenant': tenant,
      },
    };

    const result = await handleRequest<CategoryParsers.CategoryJson[]>(config);
    return result.map((r) => CategoryParsers.toCategory(r));
  }

  async function searchCategories(request: CategorySearchRequest): Promise<Category[]> {
    const config = {
      method: 'post',
      url: `${contextPath}quipli-service/yorent/v1/categories/search`,
      headers: {
        'X-Tenant': tenant,
      },
      data: request,
    };

    const result = await handleRequest<CategoryParsers.CategoryJson[]>(config);
    return result.map((r) => CategoryParsers.toCategory(r));
  }

  async function getMultipleById(categoryIds: number[]): Promise<Category[]> {
    const config = {
      method: 'post',
      url: `${contextPath}quipli-service/yorent/v1/categories/multiple`,
      headers: {
        'X-Tenant': tenant,
      },
      data: categoryIds,
    };

    const result = await handleRequest<CategoryParsers.CategoryJson[]>(config);
    return result.map((r) => CategoryParsers.toCategory(r));
  }

  async function updateCategory(categoryId: number, update: CategoryUpdateRequest) {
    const config = {
      method: 'put',
      url: `${contextPath}quipli-service/yorent/v1/categories/${categoryId}`,
      headers: {
        'X-Tenant': tenant,
      },
      data: {
        isActive: update.isActive,
        isDeleted: update.isDeleted,
      },
    };

    const result = await handleRequest<CategoryParsers.CategoryJson>(config);
    return CategoryParsers.toCategory(result);
  }

  async function updateCategoryOrder(categoryIds: number[]) {
    const config = {
      method: 'post',
      url: `${contextPath}quipli-service/yorent/v1/categories/updateOrder`,
      headers: {
        'X-Tenant': tenant,
      },
      data: {
        categoryIds,
      },
    };

    await handleRequest<any>(config);
  }

  return {
    listCategories,
    searchCategories,
    getMultipleById,
    updateCategory,
    updateCategoryOrder,
  };
};
